/**
 * The client AI terms modal: a short summary, a link to the full terms, Accept. It cannot be closed by clicking
 * outside or pressing Escape; "Not now" (when offered) leaves the studios locked and takes the person elsewhere.
 */
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { CLIENT_AI_TERMS_URL } from '@/config/legal';
import { CLIENT_AI_TERMS_SUMMARY, CLIENT_AI_TERMS_TITLE } from './clientTerms';

export function TermsModal({ open, accepting, failed, onAccept, onLater }: {
  open: boolean;
  accepting: boolean;
  failed: boolean;
  onAccept: () => void;
  onLater?: () => void;
}) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="client-terms-modal" onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle>{CLIENT_AI_TERMS_TITLE}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-left">
              <ul className="list-disc space-y-1.5 pl-5 text-[14px] leading-5 text-[#475467]">
                {CLIENT_AI_TERMS_SUMMARY.map((line) => <li key={line}>{line}</li>)}
              </ul>
              <p className="text-[13px] text-[#667085]">
                <a href={CLIENT_AI_TERMS_URL} target="_blank" rel="noopener noreferrer" className="text-[#7a1fbf] underline">Read the full terms</a>
              </p>
              {failed ? <p role="alert" className="text-[13px] text-[#b42318]">That didn't go through. Try again in a moment.</p> : null}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {onLater ? <Button variant="outline" onClick={onLater} disabled={accepting}>Not now</Button> : null}
          <Button onClick={onAccept} disabled={accepting} className="bg-[#BE43FF] text-white hover:bg-[#a83ae6]">
            {accepting ? 'Accepting' : 'Accept'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
